import { useMediaQuery } from '@mantine/hooks';

/**
 * The max-width at which we consider a viewport to be "mobile or tablet portrait".
 * Matches Mantine's `md` breakpoint (62em ≈ 992px), which covers phones and
 * portrait-mode tablets up to iPad Pro.
 *
 * Change this one constant to update the threshold across the entire app.
 */
export const MOBILE_BREAKPOINT = '(max-width: 62em)';

/**
 * Reactively reports whether the current viewport is at or below the app-wide mobile/tablet-portrait breakpoint (Mantine's `md`, ≈992px).
 *
 * @returns `true` if the viewport matches `MOBILE_BREAKPOINT`.
 */
export const useMobileBreakpoint = (): boolean =>
  useMediaQuery(MOBILE_BREAKPOINT, false) ?? false;

